import React from 'react';
import Link from 'gatsby-link';
import Slider from "react-slick";

import plusIcon from '../../img/icon-plus.png'

/**
 * Arrow next
 */
function SampleNextArrow(props) {
	const {className, style, onClick} = props;
	return (
		<div
			className={className}
			style={{...style}}
			onClick={onClick}
		>&gt;&gt;</div>
	);
}

/**
 * Arrow prev
 */
function SamplePrevArrow(props) {
	const {className, style, onClick} = props;
	return (
		<div
			className={className}
			style={{...style}}
			onClick={onClick}
		>&lt;&lt;</div>
	);
}

/**
 * Mapping items
 */
const sliderItems = (item, idx) => {
	return (
		<div className="item" key={idx}>
			<div className="content">
                <Link to={item.link}>
                    <img src={`/${item.image}`}/>
				    <div className="hover-layer">
						<div className="plus" style={{backgroundImage: `url(${plusIcon})`}}/>
					</div>
				</Link>
				<Link className="btn" to={item.link}>{item.linktext}</Link>
			</div>
		</div>
	)
};

const ProductSlider = ({data, legal}) => {
	/**
	 * Slider options
	 */
	const settings = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 2,
		slidesToScroll: 1,
		nextArrow: <SampleNextArrow/>,
		prevArrow: <SamplePrevArrow/>,
		appendDots: dots => (
			<div className="dots">
				<ul className="dot"> {dots} </ul>
			</div>
		),
		customPaging: i => (
			<div className="dot-interior"/>
		),
		responsive: [
			{
				breakpoint: 0,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					infinite: true,
					dots: true,
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
					dots: true
				}
			}
		]
	};
	return (
		<section className="product-slider">
			<div className="container">
				<div className="row">
                    <p className="legal-under-image legal-under-image--slider">{legal}</p>
					<Slider {...settings} className="product-carousel owl-carousel owl-theme">
						{data.map(sliderItems)}
					</Slider>
				</div>
			</div>
		</section>
	)
};

export default ProductSlider;



// WEBPACK FOOTER //
// ./src/components/product-slider/index.jsx